<template>
    <div class="vertical-container">
        <div class="vertical-container__content">
            <div class="container">
                <div class="onboarding">
                    <template v-if="onboarding">
                        <h1 class="onboarding__heading">Projekt založen!</h1>
                        <p class="onboarding__hero">V tomto kroku již můžete začít zakládat jednotky.</p>
                        <p class="onboarding__text">
                            Krok <strong>2</strong> ze <strong>2</strong>
                        </p>
                        <h2 class="onboarding__step">Založte první jednotku</h2>
                    </template>

                    <template v-else>
                        <h2 class="onboarding__step">Založit novou jednotku</h2>
                    </template>

                    <div class="onboarding__form onboarding__form--unit">
                        <create-unit-form ref="form" @o3-submit="onSubmit($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import CreateUnitForm from '@/modules/ProjectModule/modules/UnitModule/components/Unit/CreateUnitForm';

export default {
    components: {CreateUnitForm},
    data() {
        return {
            processing: false,
            onboarding: false,
        }
    },
    beforeMount() {
        const {query} = this.$route;
        if (query.hasOwnProperty('start') && query.start) {
            this.onboarding = true;
        }
    },
    methods:    {
        onSubmit(data) {
            this.processing = true;
            this.$store.dispatch('projects/project/units/createUnit', data)
                .then(({id}) => {
                    this.$refs.form.reset();
                    this.$router.push({name: 'project-unit-detail', params: {unitId: id}})
                })
                .catch((message) => this.$dmv.notifyError(message))
                .finally(() => this.processing = false);
        }
    }
}
</script>
